var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.006 1 13.007 7.5v.287a.778.778 0 0 1 0 .35V23.5l-12.494 7.204a.778.778 0 0 1-.219.126l-.294.17L3 23.5v-15L16.006 1zm.107 1.861 10.58 6.101-4.558 2.625-5.965-3.458a.335.335 0 0 0-.05-.024l-.007-5.242zm-.217.003L5.338 8.95l4.53 2.617 5.967-3.44a.332.332 0 0 1 .067-.03l-.006-5.234zm5.57 9.107-5.46 3.143-5.47-3.16 5.466-3.151 5.464 3.168zm-12.368.953L4.558 10.3v12.195L9.11 19.82a.332.332 0 0 1-.004-.048l-.008-6.85zm-4.413 9.75 10.562 6.09v-5.278l-5.973-3.423a.332.332 0 0 1-.065-.049l-4.525 2.66zm5.082-9.364 5.48 3.164v6.24L9.774 19.58l-.007-6.269zm7.039 10.15v5.28l10.546-6.082-4.527-2.661a.333.333 0 0 1-.096.082l-5.924 3.38zm10.648-.994V10.322l-4.556 2.622v6.844l4.556 2.678zm-10.648.224V16.45l5.424-3.121v6.265l-5.424 3.095z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFida);
export default __webpack_public_path__ + "static/media/FIDA.95771682225e682a882710da7f6f96c3.svg";
export { ForwardRef as ReactComponent };